module.exports = __webpack_public_path__ + "static/media/collision_circle.vertex.0874c0c1.glsl";